function getCsrfToken() {
  const token = document.querySelector('meta[name="csrf-token"]');
  return token ? token.content : null;
}

function handleResponse(response) {
  if (response.ok) {
    // Handle cases with no content, like a 204 response
    if (response.status === 204) {
      return Promise.resolve(null);
    }
    return response.json();
  }

  // It's an error response, try to parse the JSON body
  return response.json()
    .then(errorJson => {
      // Create a custom error object with additional data
      const errorMessage = (errorJson.errors && errorJson.errors.join(', ')) || 'Request failed';
      const error = new Error(errorMessage);
      error.status = response.status;
      error.data = errorJson;
      throw error;
    })
    .catch(err => {
      // If parsing JSON fails or we got a different error, create a standard error
      if (err.status && err.data) {
        throw err; // This is our custom error, rethrow it
      } else {
        const error = new Error(response.statusText || 'Request failed');
        error.status = response.status;
        throw error;
      }
    });
}

export function fetchPatch({ url, data }) {
  const csrfToken = getCsrfToken();
  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  };
  if (csrfToken) {
    headers['X-CSRF-Token'] = csrfToken;
  }
  return fetch(url, {
    method: 'PATCH',
    headers,
    body: JSON.stringify(data),
  }).then(handleResponse);
}

export function fetchPost({ url, data }) {
  const csrfToken = getCsrfToken();
  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  };
  if (csrfToken) {
    headers['X-CSRF-Token'] = csrfToken;
  }
  return fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(data),
  }).then(handleResponse);
}

export function fetchDelete({ url }) {
  const csrfToken = getCsrfToken();
  const headers = {
    'Accept': 'application/json',
  };
  if (csrfToken) {
    headers['X-CSRF-Token'] = csrfToken;
  }
  return fetch(url, {
    method: 'DELETE',
    headers,
  }).then(handleResponse);
}
